import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import BackIcon from "assets/icons/back.svg?react";
import ArrowLeftIcon from "assets/icons/arrow_l.svg?react";
import settingService from "api/settingsService";
import Input from "components/Input";
import HollowButton from "components/HollowButton";
import Spinner from "components/Spinner";
import { useTranslation } from "react-i18next";
import moment from "moment";

const KSeFSettings: FC<Props> = ({
  integrationId,
  onCanceled,
  handleDisconnect,
}) => {
  const { t } = useTranslation();
  const { data: settingsData, isLoading } = settingService.useGetKsefSettings();

  const settings = settingsData?.data;

  // Etykieta rodzaju podmiotu faktury (InvoiceSubjectType: 0-3) — wspólna z rejestrem KSeF.
  const subjectLabel = (subjectType: number): string => {
    switch (subjectType) {
      case 0:
        return t("ksefRegister.salesInvoices");
      case 1:
        return t("ksefRegister.purchaseInvoices");
      case 2:
        return t("ksefRegister.otherEntityInvoices");
      case 3:
        return t("ksefRegister.authorizedEntityInvoices");
      default:
        return String(subjectType);
    }
  };

  if (isLoading) {
    return <Spinner></Spinner>;
  }

  const lastSyncText = settings?.LastSync
    ? moment(settings.LastSync).format("DD.MM.yyyy HH:mm:ss")
    : t("ksefSettings.notSyncedYet");

  return (
    <div className={styles.wrapper}>
      <div className={styles.pathBar}>
        <div className={styles.backButton}>
          <BackIcon onClick={onCanceled}></BackIcon>
        </div>
        {t("integrations.title")} <ArrowLeftIcon></ArrowLeftIcon> KSeF
      </div>

      <Input
        label={t("ksefSettings.nip")}
        value={settings?.Nip ?? ""}
        onChange={() => {}}
        disabled={true}
      ></Input>

      <Input
        label={t("ksefSettings.lastSync")}
        value={lastSyncText}
        onChange={() => {}}
        disabled={true}
      ></Input>

      <div className={styles.countsHeader}>
        {t("ksefSettings.invoiceCounts")}
      </div>
      <div className={styles.counts}>
        {(settings?.SubjectCounts ?? []).map((c) => (
          <div className={styles.countRow} key={c.SubjectType}>
            <div>{subjectLabel(c.SubjectType)}</div>
            <div className={styles.countValue}>{c.Count}</div>
          </div>
        ))}
      </div>

      <div className={styles.disconnect}>
        <a onClick={() => handleDisconnect(integrationId)}>
          {t("integrations.disconnectAccount")}
        </a>
      </div>

      <div className={styles.buttons}>
        <HollowButton
          text={t("common.cancel")}
          onClick={onCanceled}
        ></HollowButton>
      </div>
    </div>
  );
};

export default KSeFSettings;
